import LongQuestion from './LongQuestion';
import FileQuestion from './FileQuestion';
import ShortQuestion from './ShortQuestion';
import EmailQuestion from './EmailQuestion';
import NumberQuestion from './NumberQuestion';
import WysiwygQuestion from './WysiwygQuestion';
import CheckboxQuestion from './CheckboxQuestion';
import DropdownQuestion from './DropdownQuestion';
import MultiSelectQuestion from './MultiSelectQuestion';

export default {
    CheckboxQuestion,
    DropdownQuestion,
    EmailQuestion,
    FileQuestion,
    LongQuestion,
    MultiSelectQuestion,
    NumberQuestion,
    ShortQuestion,
    WysiwygQuestion
};
